<template lang="html">
  <div class="wangEditor">
     <div ref="toolbar" class="toolbar">
     </div>
     <div ref="editor" class="editor-content">
     </div>
     <el-button  type="primary" v-if="this.isShowClick === true" plain class="button-send" @click="handleCommentSend">确定</el-button>
  </div>
</template>

<script>
import E from 'wangeditor';
import { API_IMG_UPLOAD, API_IMG_DOWNLOAD } from '@/common/constants';
import emotionJson from './emotions';
import { isEmpty, clone } from 'lodash';

export default {
    name: 'Editorbar',
    data () {
        return {
            editor: null,
            info_: null,
            text_: null,
            emotions: emotionJson
        };
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        isShowClick: {
            type: Boolean,
            default: true
        },
        value: {
            type: String,
            default: ''
        },
        isClear: {
            type: Boolean,
            default: false
        },
        formData: {
            type: Object
        },
        field: {
            type: Object
        }
    },
    watch: {
        isClear (val) {
            // 触发清除文本域内容
            if (val) {
                this.editor.txt.clear();
                this.info_ = null;
            }
        },
        value (val) {
            // 使用 v-model 时，设置初始值
            this.editor.txt.html(val);
        }
    },
    mounted () {
        this.seteditor();
    },
    methods: {
        async seteditor () {
            this.editor = new E(this.$refs.toolbar, this.$refs.editor);
            // this.editor.customConfig.uploadImgShowBase64 = true // base 64 存储图片
            this.editor.customConfig.uploadImgServer = API_IMG_UPLOAD;// 配置服务器端地址
            this.editor.customConfig.uploadImgHeaders = { };// 自定义 header
            this.editor.customConfig.uploadFileName = 'file'; // 后端接受上传文件的参数名
            this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
            this.editor.customConfig.uploadImgMaxLength = 1; // 限制一次最多上传 1 张图片
            this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
            this.editor.customConfig.emotions = this.emotions;
            // 配置菜单
            this.editor.customConfig.menus = [
                'head', // 标题
                'bold', // 粗体
                'fontSize', // 字号
                'fontName', // 字体
                'italic', // 斜体
                'underline', // 下划线
                'strikeThrough', // 删除线
                'foreColor', // 文字颜色
                'backColor', // 背景颜色
                'link', // 插入链接
                'list', // 列表
                'justify', // 对齐方式
                'quote', // 引用
                'emoticon', // 表情
                'image', // 插入图片
                'table', // 表格
                // 'video', // 插入视频
                // 'code', // 插入代码
                'undo', // 撤销
                'redo' // 重复
            ];
            this.editor.customConfig.uploadImgHooks = {
                fail: (xhr, editor, result) => {
                    // 插入图片失败回调
                },
                success: (xhr, editor, result) => {
                    // console.log(result);
                    // 图片上传成功回调
                    // var json = JSON.parse(xhr.responseText);
                    // var imagePath = json.data[0].filePath;
                    // var imageUrl = `${API_IMG_DOWNLOAD}${imagePath}`;
                    // console.log(imageUrl);
                },
                timeout: (xhr, editor) => {
                    // 网络超时的回调
                },
                error: (xhr, editor) => {
                    // 图片上传错误的回调
                },
                customInsert: (insertImg, result, editor) => {
                    // 图片上传成功，插入图片的回调
                    var imagePath = result.data[0].filePath;
                    var imageUrl = `${API_IMG_DOWNLOAD}${imagePath}`;
                    insertImg(imageUrl);
                }
            };
            // this.editor.customConfig.onblur = (html) => {
            //     this.info_ = html; // 绑定当前逐渐地值
            //     this.text_ = this.editor.txt.text();
            //     this.$emit('change', this.info_, this.text_); // 将内容同步到父组件中
            // };
            this.editor.customConfig.onchange = (html) => {
                this.info_ = html; // 绑定当前逐渐地值
                this.text_ = this.editor.txt.text();
                if (this.formData && this.field) {
                    this.formData[this.field.formField] = this.info_;
                }
            };
            // 创建富文本编辑器
            this.editor.create();
        },
        handleCommentSend () {
            // console.log(this.info_);
            if (isEmpty(this.info_)) {
                this.$message({message: '内容不能为空', type: 'warning'});
            } else {
                let content = clone(this.info_);
                let text = clone(this.text_);
                this.$emit('sendClick', content, text);
            }
            // // 延迟调用父组件方法,不然会出现父组件获取内容为空的情况
            // setTimeout(() => { // 调用父组件的方法
            //     this.$emit('sendClick');
            // }, 1000);
        },
        setInitValue (value) {
            if (!isEmpty(value)) {
                this.editor.txt.html(value);
            }
        }
    }
};
</script>

<style lang="less">
.wangEditor {
    height:240px;
    width: 98%;
    margin: 0 auto;
    .toolbar {
      border: 1px solid #ccc;
    }
    .editor-content {
      margin-top: -1px;//将多出来的一像素边框隐藏
      border: 1px solid #ccc;
      min-height: 200px;//编辑框最小高度
      height:auto;//编辑框高度超过最小高度会根据内容高度自适应
    }
    .button-send {
        float: right;
        // padding: 3px 0;
        margin-top: 5px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/WangEditor/WangEditor.vue